// extracted by mini-css-extract-plugin
export default {"root":"FabricFacetFilters__root___DxjUA","modal":"FabricFacetFilters__modal___Jbx2x","dropdowns":"FabricFacetFilters__dropdowns___ShMQ2"};